export default __webpack_public_path__ + "static/media/banner_bg.8bcd7cc0.png";